import type { Feature } from "geojson";

import { BaseMode } from "@/features/geojson_editor/modes/BaseMode";

export class EmptyMode extends BaseMode {
  generateMetaFeatures(): Feature[] {
    return [];
  }

  eventHandlers: BaseMode["eventHandlers"] = {};
}
